export const SINGLE = 'onetime';
export const MONTHLY = 'permonth';
export const QUARTERLY = 'quarterly';
export const SEMIANNUAL = 'semiannual';

export const PAYMENT_FREQUENCIES = {
  [MONTHLY]: {
    translationPath: 'paymentFrequencyOptions.paymentFrequencies.permonth',
    value: 'permonth',
    paymentCount: 12,
  },
  [QUARTERLY]: {
    translationPath: 'paymentFrequencyOptions.paymentFrequencies.quarterly',
    value: 'quarterly',
    paymentCount: 4,
  },
  [SEMIANNUAL]: {
    translationPath: 'paymentFrequencyOptions.paymentFrequencies.semiannual',
    value: 'semiannual',
    paymentCount: 2,
  },
  [SINGLE]: {
    translationPath: 'paymentFrequencyOptions.paymentFrequencies.onetime',
    value: 'onetime',
    paymentCount: 1,
  },
};
